import $ from 'jquery';
import MailcheckStella from 'legacy/javascripts/mailcheck_stella.js';

$(function () {
  var SolicitationPage = {
    sendSolicitationEmailInput: function () {
      return $('#solicitation-sent-to');
    },
    hadSubmittedInvalidCustomerEmail: function () {
      var solicitationPageErrors = $('.alert ul');
      return (
        solicitationPageErrors.length &&
        solicitationPageErrors.data('customerEmail')
      );
    },
  };

  if (SolicitationPage.hadSubmittedInvalidCustomerEmail()) {
    var suggestionMade = false;
    var emailInput = SolicitationPage.sendSolicitationEmailInput();
    MailcheckStella.check.call(emailInput);
  }

  $('.js-solicitation-submit').click(function (e) {
    if (
      $('.js-solicitation-channel-icon:visible').length &&
      !$('.js-multiple-channel:checked').length
    ) {
      e.preventDefault();
      $('#channel-icons').tooltip('show');
    }
  });
});
